/**
 * Accordion
 */

var toggle = document.getElementsByClassName('accordion__button');

for (let i = 0; i < toggle.length; i++) {
    toggle[i].addEventListener('click', function () {
        this.classList.toggle('-open');
        let panel = this.nextElementSibling;
        if (panel.style.display === 'block') {
            panel.style.display = 'none';
            this.setAttribute('aria-expanded', false);
        } else {
            panel.style.display = 'block';
            this.setAttribute('aria-expanded', true);
        }
    });
}
